import React from 'react';

const LoadingSkeleton = ({ text = "Loading..." }) => {
    return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center pt-20">
            <div className="relative">
                {/* Outer glowing pulse ring */}
                <div className="absolute inset-0 rounded-full bg-primary/20 animate-ping" style={{ animationDuration: '2s' }}></div>
                
                {/* Inner glowing pulse ring */}
                <div className="absolute inset-0 rounded-full bg-primary/30 animate-pulse" style={{ animationDuration: '1.5s' }}></div>
                
                {/* Logo container */}
                <div className="relative z-10 w-24 h-24 sm:w-32 sm:h-32 rounded-full glass border-2 border-primary/30 flex items-center justify-center overflow-hidden shadow-[0_0_30px_rgba(0,255,136,0.3)] animate-pulse-whatsapp">
                    <img 
                        src="/assets/logos/logo-navbar.png" 
                        alt="Zaptopay Loading" 
                        className="w-16 sm:w-20 h-auto object-contain drop-shadow-[0_0_8px_rgba(255,255,255,0.5)]"
                     loading="lazy" />
                </div>
            </div>
            
            <p className="mt-8 text-primary font-bold tracking-[0.2em] uppercase text-sm animate-pulse">
                {text}
            </p>
        </div>
    );
};

export default LoadingSkeleton;
